<template>
  <multiselect v-model="country" @search-change="search" :internal-search="false" :options="countries" track-by="codeAlpha2" label="labelSlk" openDirection="bottom" :clear-on-select="false" :close-on-select="true" :searchable="true" placeholder="Vyberte si krajinu" />
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CountrySelect',
  components: {Multiselect},
  props: {
    fetchedCountry: String
  },
  data () {
    return {
      country: null,
      countries: [],
      countriesList: []
    }
  },
  watch: {
    country (country) {
      if (country && country.codeAlpha2) {
        this.$emit('input', country.codeAlpha2)
      } else {
        this.$emit('input', '')
      }
    }
  },
  async mounted () {
    let countries = JSON.parse(localStorage.getItem('COUNTRIES'))
    if (countries != null) {
      this.countriesList = countries
    } else {
      let {data} = await this.$transparexHttp.get('/countries')
      localStorage.setItem('COUNTRIES', JSON.stringify(data))
      this.countriesList = data
    }
    this.country = this.fetchedCountry ? this.countriesList.find(country => country.codeAlpha2 === this.fetchedCountry) : this.countriesList.find(country => country.codeAlpha2 === "SK")
    this.countries = this.countriesList
  },
  methods: {
    search(query) {
      this.countries = this.countriesList.filter(country => country.labelSlk.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().includes(query.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()))
    }
  }
}
</script>
